import { Component, OnInit } from '@angular/core';

import { PermissaoNome } from 'src/app/seguranca/perfil-de-acesso/permissao/permissao-nome.enum';
import { UsuarioService } from 'src/app/seguranca/usuario/usuario/usuario.service';


@Component({
  selector: 'app-tag-acesso-a-todas-unidades',
  templateUrl: './tag-acesso-a-todas-unidades.component.html',
  styleUrls: ['./tag-acesso-a-todas-unidades.component.css']
})
export class TagAcessoATodasUnidadesComponent implements OnInit {

  public usuarioPodeAcessarTodasUnidades = false;

  constructor(private usuarioService: UsuarioService) {}

  ngOnInit(): void {
    this.usuarioPodeAcessarTodasUnidades = this.usuarioService.usuarioLogadoTemPermissao(PermissaoNome.ROLE_ACESSAR_TODAS_UNIDADES);
  }

}
